module.exports = __webpack_public_path__ + "img/00010.66865422.webp";